// extracted by mini-css-extract-plugin
export default {"rm-link":"RMLink_rm-link__t2cyh","rm-title":"RMLink_rm-title__KjsHf","strong":"RMLink_strong__jcV9B","contact-us-link":"RMLink_contact-us-link__rZFU3"};